/**
 * @generated SignedSource<<5e173cac2723d366f780bb1f1bd1b253>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksNewsAgendaFilter$data = ReadonlyArray<{
  readonly node: {
    readonly entityId: string;
    readonly newsAgenda: {
      readonly endDate: number | null | undefined;
      readonly newsAgendaOptions: ReadonlyArray<string>;
      readonly startDate: number | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"itemAgendaItemTopic" | "itemPlusNewsAgendaItemTopic">;
  };
  readonly " $fragmentType": "hooksNewsAgendaFilter";
}>;
export type hooksNewsAgendaFilter$key = ReadonlyArray<{
  readonly " $data"?: hooksNewsAgendaFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksNewsAgendaFilter">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "hooksNewsAgendaFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemAgendaItemTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemPlusNewsAgendaItemTopic"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NewsAgenda",
          "kind": "LinkedField",
          "name": "newsAgenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "newsAgendaOptions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopicEdge",
  "abstractKey": null
};

(node as any).hash = "20fadd43dfdee5235b3b1c98332da889";

export default node;
